import { Fetch, schemas, DuplicateNotebookBodyType } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { useQueryClient } from '@tanstack/react-query';

export async function duplicateNotebook(
  data: DuplicateNotebookBodyType,
  fetch: Fetch
) {
  return fetch(
    `/notebook/duplicate`,
    { method: 'post', body: JSON.stringify(data) },
    schemas.DuplicateNotebookDto
  );
}

export const useDuplicateNotebookMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['duplicateNotebook'],
    mutationFn: async (data: DuplicateNotebookBodyType) => {
      const result = duplicateNotebook(data, fetch);
      return result;
    },
    onSuccess: async () => {
      console.log('duplicated');
      await queryClient.invalidateQueries({
        queryKey: ['notebooks']
      });
    }
  });
};
